import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import HeroImage from '../components/HeroImage';
import PricingCom from '../components/PricingCom';

const Pricing = () => {
    return (
        <>
        <Navbar />
        <HeroImage titel ='Pricing.' text="Choose your trip."/>
        <PricingCom />
        <Footer />  
        </>
    );
}

export default Pricing;
